import update from 'immutability-helper'

import * as actions from '../../actions/actions'

const initialState = {
  userToCreate: {
    idBank: '',
    corporateSenderId: '',
    fullName: '',
    description: '',
    enabled: true,
    username: '',
    phone: '',
    email:'',
    reset: true,
    password: '',
    role: '',
    language:'',
    bankName:'',
    corporateName:'',
    reportSection: true,
    distinteSection: true
  },
  error: '',
  userToCreateRole:'',
  hasBankAdminCorporate: {
    corporates: '',
    corporateExist:''
  }
}

export default function userCreate(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_USER_ID_BANK_FIELD_CHANGE:
      return createUserIdBankFieldChange(state, action)
    case actions.CREATE_USER_CORPORATE_SENDER_ID_FIELD_CHANGE:
      return createUserCorporateSenderIdFieldChange(state, action)
    case actions.CREATE_USER_FULL_NAME_FIELD_CHANGE:
      return createUserFullNameFieldChange(state, action)
    case actions.CREATE_USER_DESCRIPTION_FIELD_CHANGE:
      return createUserDescriptionFieldChange(state, action)
    case actions.CREATE_USER_ENABLED_FIELD_CHANGE:
      return createUserEnabledFieldChange(state, action)
    case actions.CREATE_USER_USERNAME_FIELD_CHANGE:
      return createUserUsernameFieldChange(state, action)
    case actions.CREATE_USER_PHONE_FIELD_CHANGE:
      return createUserPhoneFieldChange(state, action)
    case actions.CREATE_USER_EMAIL_FIELD_CHANGE:
      return createUserEmailFieldChange(state, action)
    case actions.CREATE_USER_RESET_FIELD_CHANGE:
      return createUserResetFieldChange(state, action)
    case actions.CREATE_USER_PASSWORD_FIELD_CHANGE:
      return createUserPasswordFieldChange(state, action)
    case actions.CREATE_USER_ROLE_FIELD_CHANGE:
      return createUserRoleFieldChange(state, action)
    case actions.CREATE_USER_REPORT_SECTION_FIELD_CHANGE:
      return createUserReportSectionFieldChange(state, action)
    case actions.CREATE_USER_DISTINTE_SECTION_FIELD_CHANGE:
      return createUserDistinteSectionFieldChange(state, action)
    case actions.SAVE_USER_CREATE_FAILURE:
      return createUserError(state,action)
    case actions.CREATE_USER_LANGUAGE_FIELD_CHANGE:
      return createUserLanguageFieldChange(state, action)
    case actions.CREATE_USER_CLEAN:
      return createUserClean(state, action)
    case actions.CHECK_BANK_ADMIN_CORPORATE:
      return updateHasBankAdminCorporate(state, action)
    default:
      return state
  }
}

const createUserError = (state,action) => {
  return {
    ...state,
    error: action.error
  }
}

const createUserFullNameFieldChange = (state, action) => {
  return update(
    state,
    {userToCreate: {fullName: {$set: action.value}}}
  )
}

const createUserDescriptionFieldChange = (state, action) => {
  return update(
    state,
    {userToCreate: {description: {$set: action.value}}}
  )
}

const createUserEnabledFieldChange = (state, action) => {
  return update(
    state,
    {userToCreate: {enabled: {$set: action.value}}}
  )
}

const createUserUsernameFieldChange = (state, action) => {
  return update(
    state,
    {userToCreate: {username: {$set: action.value}}}
  )
}

const createUserPhoneFieldChange = (state, action) => {
  return update(
    state,
    {userToCreate: {phone: {$set: action.value}}}
  )
}

const createUserEmailFieldChange = (state, action) => {
  return update(
    state,
    {userToCreate: {email: {$set: action.value}}}
  )
}

const createUserResetFieldChange = (state, action) => {
  return update(
    state,
    {userToCreate: {reset: {$set: action.value}}}
  )
}

const createUserPasswordFieldChange = (state, action) => {
  return update(
    state,
    {userToCreate: {password: {$set: action.value}}}
  )
}

const createUserLanguageFieldChange = (state, action) => {
  return update(
    state,
    {userToCreate: {language: {$set: action.value}}}
  )
}

const createUserRoleFieldChange = (state, action) => {
  return update(
    state,
    {userToCreate: {role: {$set: action.value}}}
  )
}

const createUserReportSectionFieldChange = (state, action) => {
  return update(
      state,
      {userToCreate: {reportSection: {$set: action.value}}}
  )
}

const createUserDistinteSectionFieldChange = (state, action) => {
  return update(
      state,
      {userToCreate: {distinteSection: {$set: action.value}}}
  )
}

const createUserIdBankFieldChange = (state, action) => {
  let bankId=action.value.split(":")[0]
  let bankName=action.value.split(":")[1]
  return update(
    state,
    {userToCreate: {idBank: {$set: bankId},bankName:{$set: bankName}}}
  )
}

const createUserCorporateSenderIdFieldChange = (state, action) => {
  let corporateId=action.value.split(":")[0]
  let corporateName=action.value.split(":")[1]
  return update(
    state,
    {userToCreate: {corporateSenderId: {$set: corporateId},corporateName:{$set: corporateName}}}
  )
}

const updateHasBankAdminCorporate = (state,action) => {
  return update(
      state,
      {hasBankAdminCorporate: {corporates:{$set: action.value.corporates},corporateExist: {$set: action.value.corporateExist}}}
  )

}


const createUserClean = (state, action) => {
  return initialState;
}